<template>
    <div class="mobile-category-page">
        <HeaderMobile />
        <div class="category-header">
            <div class="header-top">
                <h2 class="page-title">课程分类</h2>
                <div class="course-count">{{ pagination.total }}门课程</div>
            </div>
            <div class="breadcrumb">
                <span class="breadcrumb-item active">{{ activeFirstCategory.name }}</span>
                <i class="el-icon-arrow-right"></i>
                <span class="breadcrumb-item">{{ activeSecondCategory.name }}</span>
            </div>
        </div>

        <div class="category-section">
            <div class="section-title">
                <i class="el-icon-s-grid"></i>
                <span>一级分类</span>
            </div>
            <div class="category-grid">
                <div 
                    class="category-card"
                    v-for="(item, index) in categoryList"
                    :key="item.id"
                    :class="{ active: activeFirstIndex === index }"
                    @click="switchFirstCategory(index)"
                >
                    <div class="card-icon">
                        <i class="el-icon-folder-opened"></i>
                    </div>
                    <div class="card-name">{{ item.name }}</div>
                </div>
            </div>
        </div>

        <div class="category-section" v-if="activeSecondList.length > 0">
            <div class="section-title">
                <i class="el-icon-menu"></i>
                <span>二级分类</span>
            </div>
            <div class="category-chips">
                <div 
                    class="chip-item"
                    v-for="item in activeSecondList"
                    :key="item.id"
                    :class="{ active: activeSecondId === item.id }"
                    @click="switchSecondCategory(item.id)"
                >
                    {{ item.name }}
                </div>
            </div>
        </div>

        <div class="course-section">
            <div class="loading-skeleton" v-if="loading">
                <div class="skeleton-card" v-for="i in 6" :key="i">
                    <div class="skeleton-cover"></div>
                    <div class="skeleton-body">
                        <div class="skeleton-title"></div>
                        <div class="skeleton-text"></div>
                    </div>
                </div>
            </div>
            <div class="empty-state" v-else-if="courseList.length === 0">
                <i class="el-icon-folder-opened"></i>
                <p>暂无相关课程</p>
            </div>

            <div class="course-list" v-else>
                <div class="course-card" v-for="course in courseList" :key="course.id" @click="goCourseDetail(course.id)">
                    <div class="course-cover">
                        <img :src="getImageUrl(course.cover)" :alt="course.name" @error="handleCoverError($event)">
                        <span class="course-tag" :class="course.is_free == 1 ? 'free-tag' : 'pay-tag'">
                            {{ course.is_free == 1 ? '免费' : '¥' + course.price }}
                        </span>
                    </div>
                    <div class="course-info">
                        <h3 class="course-title">{{ course.name }}</h3>
                        <div class="course-meta">
                            <span class="meta-item"><i class="el-icon-user"></i>{{ course.author_name }}</span>
                            <span class="meta-item"><i class="el-icon-view"></i>{{ course.looks || 0 }}</span>
                        </div>
                        <div class="course-footer">
                            <span class="student-count">{{ course.student_count || 0 }}人收藏</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pagination-wrap" v-if="pagination.total > pagination.pageSize">
                <el-pagination background layout="prev, pager, next" :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total" @current-change="handlePageChange" small></el-pagination>
            </div>
        </div>
        <FooterMobile />
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getCategory, getCategoryList } from '@/api/home';

export default {
    name: 'MobileCategoryList',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            categoryList: [],
            activeFirstIndex: 0,
            activeSecondId: null,
            courseList: [],
            loading: false,
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    computed: {
        activeFirstCategory() {
            return this.categoryList[this.activeFirstIndex] || {};
        },
        activeSecondList() {
            return this.activeFirstCategory.children || [];
        },
        activeSecondCategory() {
            return this.activeSecondList.find(item => item.id === this.activeSecondId) || {};
        }
    },
    created() {
        this.fetchCategory();
    },
    methods: {
        fetchCategory() {
            getCategory().then(res => {
                if (res.code) {
                    this.categoryList = res.data;
                    const categoryId = this.$route.params.id;
                    if (categoryId) {
                        this.findAndSetActiveCategory(parseInt(categoryId));
                    } else {
                        this.setDefaultCategory();
                    }
                }
            }).catch(() => {
                this.$message.error('获取分类列表失败');
            });
        },
        findAndSetActiveCategory(categoryId) {
            for (let i = 0; i < this.categoryList.length; i++) {
                const firstCategory = this.categoryList[i];
                if (firstCategory.id === categoryId) {
                    this.activeFirstIndex = i;
                    this.activeSecondId = firstCategory.children?.[0]?.id || null;
                    this.fetchCourseList();
                    return;
                }
                if (firstCategory.children) {
                    const secondCategory = firstCategory.children.find(child => child.id === categoryId);
                    if (secondCategory) {
                        this.activeFirstIndex = i;
                        this.activeSecondId = categoryId;
                        this.fetchCourseList();
                        return;
                    }
                }
            }
            this.setDefaultCategory();
        },
        setDefaultCategory() {
            this.activeFirstIndex = 0;
            const firstCategory = this.categoryList[0];
            if (firstCategory) {
                this.activeSecondId = firstCategory.children?.[0]?.id || firstCategory.id;
                this.fetchCourseList();
            }
        },
        fetchCourseList() {
            this.loading = true;
            getCategoryList({ 
                cid: this.activeSecondId,
                page: this.pagination.page,
                limit: this.pagination.pageSize
            }).then(res => {
                if (res.code) {
                    this.courseList = res.data.list || [];
                    this.pagination.total = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('获取课程列表失败');
            }).finally(() => {
                this.loading = false;
            });
        },
        switchFirstCategory(index) {
            this.activeFirstIndex = index;
            const category = this.categoryList[index];
            this.activeSecondId = category.children?.[0]?.id || category.id;
            this.pagination.page = 1;
            this.fetchCourseList();
        },
        switchSecondCategory(id) {
            this.activeSecondId = id;
            this.pagination.page = 1;
            this.fetchCourseList();
        },
        handlePageChange(page) {
            this.pagination.page = page;
            this.fetchCourseList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        goCourseDetail(id) {
            this.$router.push({ path: `/mobile/course/${id}` });
        },
        handleCoverError(e) {
            e.target.src = require('@/static/imgs/default.jpeg');
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        }
    },
    watch: {
        '$route.params.id'(newId) {
            if (newId) {
                this.findAndSetActiveCategory(parseInt(newId));
            }
        }
    }
};
</script>

<style scoped>
.mobile-category-page { min-height: 100vh; background: #f5f5f5; padding-bottom: 20px; padding-top: 60px; }
.category-header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 20px 16px; color: #fff; box-shadow: 0 2px 12px rgba(102,126,234,0.2); }
.header-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.page-title { font-size: 20px; font-weight: 600; margin: 0; }
.course-count { background: rgba(255,255,255,0.25); padding: 5px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; }
.breadcrumb { display: flex; align-items: center; gap: 8px; font-size: 13px; opacity: 0.95; }
.breadcrumb-item.active { font-weight: 600; }
.breadcrumb i { font-size: 10px; }
.category-section { padding: 16px; margin-bottom: 10px; }
.section-title { display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 600; color: #333; margin-bottom: 14px; }
.section-title i { color: #667eea; font-size: 16px; }
.category-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.category-card { background: #fff; border-radius: 10px; padding: 14px 8px; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.06); transition: all 0.3s ease; border: 2px solid transparent; }
.category-card.active { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; border-color: #667eea; box-shadow: 0 4px 12px rgba(102,126,234,0.35); }
.category-card:active { transform: scale(0.96); }
.card-icon { font-size: 26px; margin-bottom: 6px; }
.category-card.active .card-icon { color: #fff; }
.card-name { font-size: 12px; font-weight: 500; }
.category-chips { display: flex; flex-wrap: wrap; gap: 10px; }
.chip-item { padding: 8px 16px; background: #fff; border-radius: 18px; font-size: 13px; color: #666; box-shadow: 0 2px 6px rgba(0,0,0,0.06); transition: all 0.3s ease; border: 1px solid transparent; }
.chip-item.active { background: #667eea; color: #fff; border-color: #667eea; box-shadow: 0 3px 10px rgba(102,126,234,0.35); }
.chip-item:active { transform: scale(0.96); }
.course-section { padding: 0 16px 20px; }
.empty-state { text-align: center; padding: 60px 20px; color: #999; background: #fff; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.empty-state i { font-size: 56px; margin-bottom: 12px; display: block; color: #d0d0d0; }
.empty-state p { margin: 0; font-size: 14px; }
.course-list { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.course-card { background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); transition: all 0.3s ease; }
.course-card:active { transform: scale(0.98); box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.course-cover { position: relative; width: 100%; height: 120px; }
.course-cover img { width: 100%; height: 100%; object-fit: cover; }
.course-tag { position: absolute; top: 6px; right: 6px; padding: 4px 8px; border-radius: 4px; font-size: 11px; font-weight: 600; color: #fff; }
.free-tag { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
.pay-tag { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.course-info { padding: 12px; }
.course-title { font-size: 14px; font-weight: 500; color: #333; margin: 0 0 8px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.course-meta { display: flex; gap: 12px; margin-bottom: 6px; }
.meta-item { display: flex; align-items: center; font-size: 12px; color: #999; }
.meta-item i { font-size: 12px; margin-right: 4px; color: #1890ff; }
.course-footer { display: flex; justify-content: space-between; align-items: center; }
.student-count { font-size: 12px; color: #999; }
.pagination-wrap { display: flex; justify-content: center; margin-top: 20px; padding: 15px; background: #fff; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }

.loading-skeleton { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; padding: 0 16px; }
.skeleton-card { background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.skeleton-cover { width: 100%; height: 120px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: skeleton-loading 1.5s infinite; }
.skeleton-body { padding: 12px; }
.skeleton-title { height: 14px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: skeleton-loading 1.5s infinite; border-radius: 4px; margin-bottom: 8px; }
.skeleton-text { height: 12px; width: 60%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: skeleton-loading 1.5s infinite; border-radius: 4px; }
@keyframes skeleton-loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
</style>
